module.exports = __webpack_public_path__ + "img/0c02bae673ae5ebde7710f13e2f76269.0c02bae6.png";